{
  "appName": "PACT Act",
  "entryFile": "./pact-act-entry.jsx",
  "entryName": "pact-act",
  "rootUrl": "/pact-act-eligibility"
}
